import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';

import CarouselHero from './Carousel';
import Default from './Default';
import Headliner from './Headliner';
import News from './News';

import type { HomePageLoaderData } from '~/routes';

const Hero = () => {
  const { homePage } = useTypedLoaderData<HomePageLoaderData>();
  const variant = homePage.general_section.theme.header_type;

  switch (variant) {
    case 'carousel':
      return <CarouselHero />;
    case 'headliner':
      return <Headliner />;
    case 'news':
      return <News />;
    default:
      return <Default />;
  }
};

export default Hero;
